module.exports = __webpack_public_path__ + "static/media/wil_logo-white.99aaf769.svg";